import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class IpWhiteListStrService {
    i18n = {
        addBtn: this.get('common.add_button'),
        modifyBtn: this.get('common.modify_button'),
        removeBtn: this.get('common.remove_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),

        rules: this.get('settings.securityPolicy_term_IP_lab'),
        id: this.get('common.ID_column'),
        addIpWhiteListTitle: this.get('service.share_task_accessibleIP_AddIPAddress_title'),
        modifyIpWhiteListTitle: this.get('service.share_task_accessibleIP_modifyIPAddress_title'),
        removeIpWhiteListTitle: this.get('service.share_task_accessibleIP_DeleteIPAddress_title'),

        helpTip: this.get('service.share_task_accessibleIP_addIP_tip'),
        ipWhiteListTips: this.get('service.share_task_accessibleIP_enterIPRule_tip'),
        ipWhiteListModifyTips: this.get('service.share_task_accessibleIP_modifyIP_tip'),
        removeIpWhiteListTip: this.get('service.resourceDistribute_task_CreateCIFS_DeleteIP_msg'),

        ipFormatErr: this.get('common.IPAddress_format_example_validation', [this.get('service.share_task_accessibleIP_example_value')]),
        ipTypeErr: this.i18nService.get('settings.securityPolicy_term_task_setIPRule_para_endIP_principle_validation'),
        ipRepeatErr: this.get('common.allCanNotEquall_msg', [this.get('settings.securityPolicy_term_IPSegmentAndIP_column')]),
        ipRangeErr: this.get('settings.securityPolicy_term_task_setIPRule_para_startIP_range_validation'),

        addIpWhiteListAction: (value: string): string => this.get('rest.addAccessibleIP_msg', [value]),
        modifyIpWhiteListAction: (value: string): string => this.get('rest.modifyAccessibleIP_msg', [value]),
        removeIpWhiteListAction: (value: string): string => this.get('rest.removeAccessibleIP_msg', [value]),
    };

    constructor(
        private i18nService: I18nService,
    ) {
    }

    get(key: string, params?: string[] | boolean, colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }

}
